import React from 'react'
import creditPhoto from '../assets/credit.jpg'
import feedPhoto from '../assets/feed.jpg'
import orderPhoto from '../assets/order.jpg'
import schedulePhoto from '../assets/schedule.jpg'
import userPhoto from '../assets/user.jpg'
import { FlatList, TouchableOpacity, ImageBackground, View, Text, Dimensions } from 'react-native'
import { useHeaderHeight } from '@react-navigation/stack';
import { Box } from 'native-base'

export default function Home(props) {
    const { t, QRScannerModalVisible } = props
    const headerHeight = useHeaderHeight();

    const routes = [
        { title: t('MemberList'), route: 'MemberList', imageUrl: userPhoto },
        { title: t('OrderList'), route: 'OrderList', imageUrl: orderPhoto },
        { title: t('ReservationList'), route: 'ReservationCalendar', imageUrl: schedulePhoto },
        // { title: t('Feed'), route: 'FeedList', imageUrl: feedPhoto },
        { title: t('CreditList'), route: 'CreditList', imageUrl: creditPhoto },
    ]


    const renderRoutesView = (object) => {
        const { item } = object
        const { title, route, imageUrl } = item
        return (
            <TouchableOpacity style={{ flexDirection: 'row', padding: 20 }} onPress={() => props.onPress(route)}>
                <ImageBackground style={{ width: '100%', padding: 20, alignItems: 'center', justifyContent: 'center', }} source={imageUrl}>
                    <View style={{ backgroundColor: 'black', padding: 20, paddingLeft: 40, paddingRight: 40 }}>
                        <Text style={{ color: 'white', fontSize: 26 }}>{title}</Text>
                    </View>
                </ImageBackground>
            </TouchableOpacity>
        )
    }

    return (
        <Box h={Dimensions.get('window').height - headerHeight} bgColor={"white"} p={2}>
            <FlatList
                data={routes}
                renderItem={(object) => renderRoutesView(object)}
                keyExtractor={(item, index) => index.toString()}
            />
        </Box>
    )
}
